module.exports = __webpack_public_path__ + "img/email-icon.6bdb7f80.svg";